export default __webpack_public_path__ + "static/media/bg-league.c4ce277e.png";